import { useQuery } from '@tanstack/react-query';
import { getFlashbookDesign } from '../../services/flashbooks';

function useGetFlashbookDesign({
  flashbookId,
  flashDesignId,
  enabled = true,
}: {
  flashbookId: string | undefined;
  flashDesignId: number | undefined;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: ['flashbook-design', { flashbookId, flashDesignId }],
    enabled: !!flashbookId && !!flashDesignId && enabled,
    queryFn: () =>
      getFlashbookDesign({
        flashbookId: flashbookId!,
        flashDesignId: flashDesignId!,
      }),
  });
}

export default useGetFlashbookDesign;
